<template>
  <!-- 최상위 div 시작 -->
  <div>
    <!-- 반복되는 노드 영역 -->
    <div
      class="node pl--20px"
      @drag.stop="drag"
      @dragstart.stop='dragStart'
      @dragover.stop='dragOver'
      @dragenter.stop='dragEnter'
      @dragleave.stop='dragLeave'
      @drop.stop='drop'
      @dragend.stop='dragEnd'
      draggable="true"
      :style="`color: ${styleObj.selected ? 'red' : 'black'}`"
    >
      <div
        class="border my--4px position--relative gray lighten-5"
        @click.stop="selectNone"
      >
        <!-- 드래그 버튼 -->
        <span
          class="
          inline-block 
          cursor--pointer 
          w--44px 
          h--44px
          text--center
          lh--44px
          white
          border-r--1px
        "
          @click.stop="open"
        >
          <i
            class="material-icons font--18px"
            :class="opend ? 'nodeClicked' : ''"
          >play_arrow</i>
        </span>
        <!-- 드래그 버튼 -->
        <span class="
          inline-block 
          cursor--move 
          w--44px 
          h--44px
          text--center
          lh--44px
          mr--16px
          border-r--1px
          white
        ">
          <i class="material-icons font--18px">drag_handle</i>
        </span>
        <!-- 노드 라벨 -->
        <strong
          class="font--12px"
          @click.stop="select"
        >{{node.type}}</strong>

        <!-- add child / delete 영역 -->
        <div class="position--absolute top--6px right--6px">
          <!-- add child 버튼 -->
          <!-- <button class="
            inline-block 
            h--32px
            mr--4px
            text--center
            lh--32px
            border
            white
            font--12px
            px--8px
            text--middle
          ">
            <i class="material-icons font--18px">add_circle_outline</i>
            add child
          </button> -->
          <!-- delete 버튼 -->
          <button
            class="
            inline-block 
            w--32px 
            h--32px
            text--center
            lh--32px
            border
            white
            text--middle        
          "
            type="button"
            @click.stop="remove"
          >
            <i class="material-icons font--18px">delete_outline</i>
          </button>
        </div>
      </div>
      <div
        @dragenter.stop='dragEnter2'
        @dragleave.stop='dragLeave2'
        @drop.stop='drop2'
        :style="`background-color: ${styleObj.color}`"
      >======</div>
      <!-- 자식노드 추가 : 현재 주석 하단에 추가 -->
      <template v-if="opend && node.hasOwnProperty('components')">
        <tree-node
          v-for="(child, index) in node.components"
          :key="index"
          :node="child"
          :parent="node"
          :parents="myParents"
          :index="index"
        ></tree-node>

      </template>
      <!-- 자식노드 끝 -->
    </div><!-- 반복되는 노드 영역 끝 -->

    <!-- 형제노드 추가 : 현재 주석 하단에 추가 -->
    <!-- 형제노드 끝 -->

  </div><!-- 최상위 div 끝 -->
</template>

<script>
import eventBus from '@/component/common/EventBus'

export default {
  name: 'TreeNode',
  props: {
    node: { type: Object },
    parent: { type: Object },
    parents: { type: Array },
    index: { type: Number, required: true }
  },
  data () {
    return {
      styleObj: {
        color: 'white',
        selected: false
      },
      opend: false
    }
  },
  computed: {
    myParents () {
      return this.parents.concat([this])
    }
  },
  created () {
    eventBus.$on('select-tree-node', this.onSelectTreeNode)
  },
  methods: {
    onSelectTreeNode (node, component, e) {
      this.styleObj.selected = false
      if (component && component._uid === this._uid) {
        this.styleObj.selected = true
      }
    },
    open () {
      if (this.node.hasOwnProperty('components') && this.node.components.length > 0) {
        this.opend = !this.opend
      }
    },
    remove (e) {
      eventBus.$emit('remove-tree-node', this.node, this, e)
    },
    select (e) {
      eventBus.$emit('select-tree-node', this.node, this, e)
    },
    selectNone (e) {
      eventBus.$emit('select-tree-node', null, null, e)
    },
    drag (e) {
      eventBus.$emit('drag-tree-node', this.node, this, e)
    },
    dragStart (e) {
      // e.dataTransfer.effectAllowed = 'move'
      // e.dataTransfer.setData('text/plain', 'asdad')
      return true
    },
    dragOver (e) {
      e.preventDefault()
      // rootTree.emitDragOver(this.model, this, e)
      return true
    },
    dragEnter (e) {
      // if (this._uid !== fromData._uid) {
      //   this.styleObj.opacity = 0.5
      // }
      eventBus.$emit('drag-enter-tree-node', this.node)
      // rootTree.emitDragEnter(this.model, this, e)
    },
    dragLeave (e) {
      // this.styleObj.opacity = 1
      // rootTree.emitDragLeave(this.model, this, e)
    },
    drop (e) {
      e.preventDefault()
      // this.styleObj.opacity = 1
      // 현재 노드가 존재하지 않는다고 판단하면drop，return;
      // if (!this.allowDrop(this.model, this)) {
      //   return
      // }
      // toData = this
      // console.log('===', fromData.model.name, '---->', toData.model.name)

      // exchangeData(rootTree, fromData, toData)
      // rootTree.emitDrop(this.model, this, e)
      eventBus.$emit('drop-tree-node', this.node, this, e)
    },
    dragEnd (e) {
      // rootTree.emitDragEnd(this.model, this, e)
    },
    dragEnter2 (e) {
      this.styleObj.color = 'red'

      // if (this._uid !== fromData._uid) {
      // this.styleObj.opacity = 0.5
      // }
      // eventBus.$emit('drag-enter-tree-node', this.node, this, e)
      // rootTree.emitDragEnter(this.model, this, e)
    },
    dragLeave2 (e) {
      this.styleObj.color = 'white'
    },
    drop2 (e) {
      this.styleObj.color = 'white'

      e.preventDefault()
      eventBus.$emit('drop-tree-node-sibling', this.node, this, e)
    }
  },
  components: {
    TreeNode: () => import('./TreeNode')
  }
}
</script>

<style>
.nodeClicked {
  transform: rotate(90deg);
}
</style>
